import React from "react";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Philosophy from "@/components/site/Philosophy";
import Classes from "@/components/site/Classes";
import Strength from "@/components/site/Strength";
import BibliotecaPreview from "@/components/site/BibliotecaPreview";
import Experience from "@/components/site/Experience";
import Studios from "@/components/site/Studios";
import Team from "@/components/site/Team";
import Trial from "@/components/site/Trial";
import AppDownload from "@/components/site/AppDownload";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import AppStrip from "@/components/site/AppStrip";

export default function Home() {
  return (
    <main className="bg-[var(--luft-bg)]" data-testid="home-page">
      <Navigation />
      <Hero />
      <Philosophy />
      <Classes />
      <Strength />
      <BibliotecaPreview />
      <Experience />
      <Studios />
      <Team />
      <Trial />
      <AppDownload />
      <Contact />
      <Footer />
      <AppStrip />
    </main>
  );
}
